import instances from './map';

export const getContractNumber = async pcodbenef =>
  instances
    .beneficiario_odonto({
      method: 'GET',
      url: '/beneficiarios',
      params: {
        pcodbenef
      },
      headers: {
        access_token: instances.prestador_odonto.defaults.headers.access_token
      }
    })
    .then(response => {
      const normalizedResponse = response.data.beneficiarioModels;
      if (response.data.mensagemErro)
        return Promise.reject(new Error(response.data.mensagemErro.descricao));
      return normalizedResponse;
    });

export const getElegibility = async ({ codBenef, contrato, codPrest, codServico }) =>
  instances
    .beneficiario_odonto({
      method: 'GET',
      url: '/beneficiarios/elegibilidade',
      params: {
        codBenef,
        contrato,
        codPrest,
        codServico
      },
      headers: {
        access_token: instances.prestador_odonto.defaults.headers.access_token
      }
    })
    .then(response => {
      let normalizedResponse = response.data;
      if (response.data.mensagemErro) {
        if (/1014(.*)/.test(response.data.mensagemErro.descricao)) {
          normalizedResponse = { flagElegivel: false, mensagemErro: response.data.mensagemErro.descricao };
        } else if (response.data.mensagemErro.descricao.includes("atendimento ao produto")) {
          return Promise.reject(new Error("Prezado (a) Prestador (a), você não está contratado para o atendimento ao produto deste beneficiário."));
        } else {
          return Promise.reject(new Error(response.data.mensagemErro.descricao));
        }
      }

      if (/1004(.*)/.test(response.data.msgRetorno)) {
        let descErro = "Não é possível seguir com a solicitação do tratamento, beneficiário apresenta vigência futura. " + response.data.msgRetorno;
        normalizedResponse = { flagElegivel: false, mensagemErro: descErro, msgRetorno: descErro };
      }

      return normalizedResponse;
    });
export default { getElegibility, getContractNumber };